import { useEffect } from 'react'
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom'

import { useUnsafeCallback } from 'modules/core/hooks/useCallback'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import NuvoImporter from 'modules/universal_importer/components/NuvoImporter'

const ImportFteModalPage = () => {
  const navigate = useNavigate()
  const { state } = useLocation()
  const { navigation } = useNavigation()

  const { canSeeFinanceWorkspace } = useOutletContext<{
    canSeeFinanceWorkspace: boolean
  }>()

  const {
    access: { locale },
    company: { id: companyId },
  } = useCurrentSession()

  const onClose = useUnsafeCallback(() => {
    navigate(navigation.finance.financialWorkspace.employee_costs.fullPath())
  }, [navigate, navigation])

  useEffect(() => {
    if (!canSeeFinanceWorkspace) {
      onClose()
    }
  }, [canSeeFinanceWorkspace, onClose])

  if (!canSeeFinanceWorkspace) {
    return null
  }

  return (
    <NuvoImporter
      isEdition
      locale={locale}
      companyId={companyId}
      importType="working_time_percentage_importer"
      metadata={{ employee_ids: state.employeeIds ?? [] }}
    />
  )
}

export default ImportFteModalPage
